// Intercept qty clicks EARLY (capture phase) so theme handlers can't also fire
(function () {
  function onQtyClick(e) {
    const btn = e.target.closest(
      '[data-qty-plus],[data-qty-minus],[data-action="increase"],[data-action="decrease"],.quantity__button,.qty__button,.bh-qty__btn'
    );
    if (!btn) return;

    // Block native handlers to avoid double updates
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    // Determine + / -
    const label = (btn.getAttribute?.('aria-label') || btn.title || btn.textContent || '').toLowerCase().trim();
    const isPlus =
      btn.matches?.('[data-qty-plus],[data-action="increase"],.quantity__button--plus,.bh-qty__btn--plus') ||
      /\b(\+|increase|plus|add)\b/.test(label);
    const isMinus =
      btn.matches?.('[data-qty-minus],[data-action="decrease"],.quantity__button--minus,.bh-qty__btn--minus') ||
      /(^-| minus|decrease|remove)/.test(label);
    if (!isPlus && !isMinus) return;

    // Find related input
    const lineWrap = btn.closest('[data-cart-item], .cart-item, .cart__line-item, li, tr, .quantity, .cart-item__quantity') || document;
    const input =
      lineWrap.querySelector('input[name="updates[]"], input[name="quantity"]') ||
      document.querySelector('input[name="updates[]"]');
    if (!input) return;

    // Adjust by exactly 1 step
    const min  = input.min ? parseInt(input.min, 10) : 0;
    const step = input.step ? parseInt(input.step, 10) : 1;
    let next   = parseInt(input.value || '0', 10) || 0;
    next = isPlus ? next + step : next - step;
    if (next < min) next = min;
    input.value = String(next);

    // Persist via Shopify AJAX (works even if theme JS is bypassed)
    let line = null;
    const m = input.id && input.id.match(/Quantity-(\d+)/i);
    if (m) line = parseInt(m[1], 10);

    let key = null;
    const keyEl = lineWrap.closest('[data-key]') || lineWrap.querySelector('[data-key]');
    if (keyEl && keyEl.dataset) key = keyEl.dataset.key;

    const payload = line ? { line, quantity: next } : key ? { id: key, quantity: next } : null;

    if (payload) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      })
      .then(() => location.reload())
      .catch(console.error);
    } else if (input.form) {
      input.form.submit();
    }
  }

  // Capture phase listener ensures this runs BEFORE theme handlers on the button
  document.addEventListener('click', onQtyClick, true);
})();


